import { UsersHistoryModel as Model } from './Model'


export const MODULE_NAME = 'users.history'

export const USERS_HISTORY_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: USERS_HISTORY_ROUTES.LAYOUT,
  route: { name: USERS_HISTORY_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-account-clock-outline',
} as const
